var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPreviousDiscountCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 49,
    viewBox: "0 0 10 49",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0H0V2.28606C1.29942 2.50178 2.28896 3.60965 2.28896 4.94391C2.28896 6.27817 1.29942 7.38604 0 7.60175V9.92278C1.29942 10.1385 2.28896 11.2464 2.28896 12.5806C2.28896 13.9149 1.29942 15.0228 0 15.2385V17.5634C1.29942 17.7791 2.28896 18.887 2.28896 20.2213C2.28896 21.5555 1.29942 22.6634 0 22.8791V25.2001C1.29942 25.4158 2.28896 26.5237 2.28896 27.858C2.28896 29.1922 1.29942 30.3001 0 30.5158V32.8388C1.29942 33.0545 2.28896 34.1624 2.28896 35.4966C2.28896 36.8309 1.29942 37.9388 0 38.1545V40.4775C1.29942 40.6932 2.28896 41.8011 2.28896 43.1353C2.28896 44.4696 1.29942 45.5774 0 45.7932V48H5V0Z",
    fill: "#FF8C21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPreviousDiscountCode);
export default __webpack_public_path__ + "static/media/icon-previous-discount-code.3cc87407d5c58556a4b035976b049288.svg";
export { ForwardRef as ReactComponent };